import axios from 'axios';

/**
 * A `Date` in a request body is a DATE, and it leaves as one.
 *
 * The date editors hand us a JavaScript `Date` at LOCAL midnight for the day
 * that was clicked, and `JSON.stringify` writes a `Date` in UTC - so a browser
 * east of Greenwich sent the day BEFORE, and 259 rows in production carry it.
 * `getFullYear/getMonth/getDate` read back the local day, which is the one the
 * person chose.
 *
 * Here rather than on each screen because there are four of them and the next
 * one would not know: every write in this application goes through `apiRequest`,
 * so this is the only place where it cannot be forgotten. `toISOString()` is the
 * thing being avoided and must not come back.
 */
const asDateOnly = value => {
  if (value instanceof Date) {
    const pad = n => String(n).padStart(2, '0');
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }
  if (Array.isArray(value)) {
    return value.map(asDateOnly);
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce(
      (out, key) => ({ ...out, [key]: asDateOnly(value[key]) }), {}
    );
  }
  return value;
};

export const apiRequest = (
  url = undefined,
  method = undefined,
  data = undefined,
  headers = {}
) => {

  const requestOptions = {
    method: method ? method : 'get',
    url: process.env.API_URL + (url ? url : '/'),
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*',
      ...headers
    },
    // The credential is a cookie now, and axios does not send cookies
    // cross-origin unless told to. This is the telling. The API names our
    // origin and answers Access-Control-Allow-Credentials, which is the other
    // half of the same handshake.
    withCredentials: true
  };
  if (data) {
    requestOptions['data'] = asDateOnly(data);
  }
  return axios(requestOptions);
};

export const apiRequestDirectURL = url => {
  const requestOptions = {
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*'
    }
    // No withCredentials, and it would change nothing if there were: the cookie
    // is host-only, so it is never sent anywhere but api.reachok.eu whatever
    // this flag says. This fetches the ECHA sheets off Google Drive, and the
    // flag is absent because it is not needed, not because it is a defence.
  };
  return axios(requestOptions);
};

